import { SEO } from "@/components/SEO";
import { ConsistencyCornerHero } from "../components/site/consistency-corner/ConsistencyCornerHero";
import { MaybeThisSoundsFamiliar } from "../components/site/consistency-corner/MaybeThisSoundsFamiliar";
import { WhyItWorks } from "../components/site/consistency-corner/WhyItWorks";
import { WhatConsistencyCornerIs } from "../components/site/consistency-corner/WhatConsistencyCornerIs";
import { WhatHappensEachWeek } from "../components/site/consistency-corner/WhatHappensEachWeek";
import { WhatYouCanBring } from "../components/site/consistency-corner/WhatYouCanBring";
import { ThisMayBeForYou } from "../components/site/consistency-corner/ThisMayBeForYou";
import { Membership } from "../components/site/consistency-corner/Membership";
import { FinalCTA } from "../components/site/consistency-corner/FinalCTA";

export default function ConsistencyCorner() {
  return (
    <div data-testid="consistency-corner-page">
      <SEO
        title="Consistency Corner"
        description="A weekly place to return to what matters. Consistency Corner is a gentle weekly gathering where you can pause, reconnect and take one honest step forward."
        path="/work-with-me/consistency-corner"
      />
      <ConsistencyCornerHero />
      <MaybeThisSoundsFamiliar />
      <WhyItWorks />
      <WhatConsistencyCornerIs />
      <WhatHappensEachWeek />
      <WhatYouCanBring />
      <ThisMayBeForYou />
      <Membership />
      <FinalCTA />
    </div>
  );
}
